import { useNavigation, NavigationProp } from "@react-navigation/native";
import useCountdown from "hooks/useCountdown";
import { EventNavigationParamList } from "navigation/EventNavigation/types";
import { SCREENS } from "navigation/consts";
import { useOrderContext } from "providers/OrderProvider/hooks";
import { useCallback, useMemo } from "react";
import parseDate from "utils/parseDate";

import { OrderSession } from "./types";

const useOrderSession = (): OrderSession => {
  const { order, resetOrder } = useOrderContext();
  const expireAt = useMemo(() => parseDate(order?.expireAt), [order?.expireAt]);
  const [expireIn] = useCountdown({ date: expireAt });
  const { navigate } =
    useNavigation<NavigationProp<EventNavigationParamList>>();

  const onReset = useCallback(async () => {
    await resetOrder();
    navigate(SCREENS.Cart);
  }, [navigate, resetOrder]);

  return {
    expireAt,
    expireIn,
    isExpired: expireIn === 0,
    onReset,
  };
};

export default useOrderSession;
